import { css, cx } from '@eti/styles';
import { constants } from '@eti/utils';
import { useAsset } from '../../custom-hooks/asset';
import { AssetType } from '../../custom-hooks/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const generateStyle = (height, width, top) => ({
  ...(height ? {
    height
  } : {}),
  ...(width ? {
    width
  } : {}),
  ...(top ? {
    marginTop: top
  } : {})
});
const fadeInStyles = css`
  animation: fadeIn 2s;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
const mirroredStyles = css`
  transform: rotateY(180deg);
`;
const {
  FLIGHTNETWORK,
  GOTOGATE,
  MYTRIP
} = constants.brands;
const BRAND_TO_FOLDER = {
  [FLIGHTNETWORK]: 'flightnetwork',
  [GOTOGATE]: 'gotogate',
  [MYTRIP]: 'mytrip'
};
const hasABrandFolder = function (brand) {
  if (brand === void 0) {
    brand = '';
  }
  return Object.prototype.hasOwnProperty.call(BRAND_TO_FOLDER, brand);
};
const Illustration = _ref => {
  let {
    brand,
    className,
    'data-testid': dataTestid,
    isGraphic = false,
    height,
    id,
    onClick,
    width,
    size,
    top,
    mirrored,
    ...rest
  } = _ref;
  const brandFolder = hasABrandFolder(brand) ? BRAND_TO_FOLDER[brand] : 'default';
  const {
    ReactComponent
  } = useAsset(AssetType.Illustration, id, brandFolder);
  const reactComponentProps = {
    pointerEvents: 'all',
    'aria-hidden': isGraphic ? undefined : 'true',
    className: cx('etiIllustration', className, fadeInStyles, mirrored && mirroredStyles),
    onClick,
    role: isGraphic ? 'img' : 'presentation',
    style: generateStyle(height || size, width || size, top),
    ...rest
  };
  return ReactComponent ? /*#__PURE__*/_jsx(ReactComponent, {
    "data-testid": dataTestid,
    ...reactComponentProps
  }) : /*#__PURE__*/_jsx("div", {
    className: className,
    "data-testid": dataTestid
  });
};
export default Illustration;
//# sourceMappingURL=Illustration.js.map